import { useEffect, useState } from 'react'
import { Check, Copy, Eye, EyeOff } from 'lucide-react'

import { Alert, CopyButton, Icon, IconButton } from 'ui'

export const ServerTokenDisplay = ({ actions, token }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(false)
  }, [token])

  if (!token) {
    return <Alert color="danger">Unable to load the current server token.</Alert>
  }

  return (
    <div className="tw:flex tw:min-h-14 tw:items-center tw:rounded-input tw:border tw:border-default tw:bg-surface-muted tw:px-4">
      <span className="ds-mono tw:min-w-0 tw:flex-1 tw:truncate">
        {isVisible ? token : '•'.repeat(token.length)}
      </span>
      <div className="tw:ml-3 tw:flex tw:items-center">
        <CopyButton
          copiedIcon={<Icon as={Check} />}
          copyIcon={<Icon as={Copy} />}
          copyLabel="Copy Server Token"
          text={token}
        />
        <IconButton
          label={isVisible ? 'Hide Server Token' : 'Show Server Token'}
          onClick={() => setIsVisible(visible => !visible)}
        >
          <Icon as={isVisible ? EyeOff : Eye} />
        </IconButton>
        {actions}
      </div>
    </div>
  )
}

export default ServerTokenDisplay
